<template>
  <div class="reportList" v-loading='loading'>
    <el-tabs v-model="activeName2" type="card" @tab-click="handleClick">
      <el-tab-pane label="全部报告" name="allList"></el-tab-pane>
      <el-tab-pane label="待诊断" name="waitList"></el-tab-pane>
      <el-tab-pane label="诊断中" name="startList"></el-tab-pane>
      <el-tab-pane label="已诊断" name="endList"></el-tab-pane>
    </el-tabs>
    <el-row class="reportList-nav" id="reportListnav">
      <el-col :class="{'toggleSearchType':isActive}">
        <el-form :inline="true" :model="search" ref="search" size="mini" class="demo-form-inline">
          <el-row class="nav-top">
            <el-form-item label prop="patientName">
              <el-input v-model="search.patientName" placeholder="患者姓名"></el-input>
            </el-form-item>
            <el-form-item label prop="patientNo">
              <el-input v-model="search.patientNo" placeholder="影像号"></el-input>
            </el-form-item>
            <el-form-item label prop="RegNo">
              <el-input v-model="search.RegNo" placeholder="登记单号"></el-input>
            </el-form-item>
            <el-form-item label prop="SrcHospitalName">
              <el-input v-model="search.SrcHospitalName" placeholder="检查医院"></el-input>
            </el-form-item>
            <el-form-item label prop="PatientType">
              <el-select v-model="search.PatientType" placeholder="患者来源">
                <el-option
                  v-for="item in dict.patientSource"
                  :key="item.id"
                  :label="item.dictName"
                  :value="item.dictName"
                ></el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="" prop="SubmitterName">
              <el-input v-model="search.SubmitterName" placeholder="诊断医生"></el-input>
            </el-form-item>-->
            <el-form-item style="width:7%;min-width: 60px;">
              <el-button
                style="width:100%;"
                type="primary"
                icon="el-icon-search"
                @click="onSubmit(1)"
              >查询</el-button>
            </el-form-item>
            <el-form-item style="width:7%;min-width: 60px;">
              <el-button
                style="width:100%;"
                type="success"
                icon="el-icon-circle-close-outline"
                @click="resetForm"
              >清空</el-button>
            </el-form-item>
            <!-- <el-form-item  style="width:7%;min-width: 60px;">
              <el-button  @click="Excel" size='mini' style="width:100%;"
                type="primary">导出Excel</el-button>
            </el-form-item> -->
            <el-form-item style="float:right;margin-bottom:0px;margin-right:0px;width:5%;">
              <el-button
                style="font-size:18px;width:50px;color: #3A4A64;font-size: 21px;"
                type="text"
                @click="toggleClick"
              >
                <i :class="{'is-active':isActive}" class="hamburger el-icon-arrow-down"></i>
              </el-button>
            </el-form-item>

          </el-row>
          <div class="toggleSearch">
            <el-row>
              <el-col>
                <el-form-item label="检查时间">
                  <el-radio-group v-model="timeType">
                    <el-radio-button
                      v-for="item in getTime"
                      :key="item.Value"
                      :label="item.Value"
                    >{{item.Text}}</el-radio-button>
                    <el-radio-button label="4" class="nav-time">
                      <el-date-picker
                        v-model="search.DateArray"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        @change="changeTime"
                      ></el-date-picker>
                    </el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="设备类型">
                  <el-radio-group v-model="search.Modality" @change="onSubmit(1)">
                    <el-radio-button label>全部</el-radio-button>
                    <el-radio-button
                      v-for="item in checkList.checkType"
                      :key="item.name"
                      :label="item.name"
                    >{{item.name}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <el-form-item label="检查部位">
                  <el-radio-group v-model="search.bodyPart" @change="onSubmit(1)">
                    <el-radio-button label>全部</el-radio-button>
                    <el-radio-button
                      v-for="item in checkList.checkBody"
                      :key="item.name"
                      :label="item.name"
                    >{{item.name}}</el-radio-button>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <div class="reportList-table">
      <el-table
        v-if="writeReportList.length > 0"
        :row-class-name="tableRowClassName"
        stripe
        :data="writeReportList"
        size="mini"
        v-loading="tableloading"
        style="width: 100%"
        @row-dblclick="dbTalble"
      >
        <el-table-column :fixed="index === 0" v-if="col.isShow" v-for="(col, index) in headerList"
          :key="index"
          :min-width="col.width"
          :prop="col.prop"
          :label="col.label"
          :show-overflow-tooltip = 'true'
        >
          <template slot-scope="scope">
            <span  v-if="index === 0" style="font-size:20px;">
              <span v-if='scope.row.hasAIResult' @click="openAi(scope.row.aiResultWebUrl)">
                <svg-icon  icon-class='A_I' ></svg-icon>
              </span>
            </span>
            <el-popover trigger="hover" placement="top" v-if="col.prop === 'checkingItems'">
              {{ scope.row[col.prop] | checkingItems}}
              <div slot="reference" class="name-wrapper">
                <span style="background: #ff9d60;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop] | checkingItems}}</span>
                <div v-else></div>
              </div>
            </el-popover>
            <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'modalityName'">
              {{ scope.row[col.prop]}}
              <div slot="reference" class="name-wrapper">
                <span style="background: #FF8C8C;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                <div v-else></div>
              </div>
            </el-popover>
            <el-popover trigger="hover" placement="top" v-else-if="col.prop === 'bodyParts'">
              {{ scope.row[col.prop]}}
              <div slot="reference" class="name-wrapper">
                <span style="background: #49C1E4;" v-if='scope.row[col.prop]'>{{ scope.row[col.prop]}}</span>
                <div v-else></div>
              </div>
            </el-popover>
            <span v-else>
              {{scope.row[col.prop]}}
            </span>
          </template>
          
        </el-table-column>
        <!-- <el-table-column prop='patientName' align='center' label='姓名' width='100px'>
              <template slot-scope="scope">
                <el-popover trigger="hover" placement="top" v-if='scope.row.sendType!==0'>
                    <span style="text-align:center;" v-if='scope.row.sendType===2'>收到{{scope.row.col.prop}}的远程请求</span>
                    <span style="text-align:center;" v-if='scope.row.sendType===1'>发往{{scope.row.destHospitalName}}的远程请求</span>
                  <div slot="reference" class="">
                    <div style="text-align:center;">{{ scope.row.patientName }} <svg-icon v-if='scope.row.sendType===2' icon-class='from-outside'></svg-icon><svg-icon v-if='scope.row.sendType===1' icon-class='to-outside'></svg-icon></div>
                    <span v-if='scope.row.regIsEmergency' style="width: 29px;position: absolute;left: 0;top: 0;display:inline-block;"><img style="width:100%;" src="../../assets/Emergency.png" alt=""></span>
                  </div>
                </el-popover>
                <div v-else>
                  <div style="text-align:center;">{{ scope.row.patientName }} <svg-icon v-if='scope.row.sendType===2' icon-class='from-outside'></svg-icon><svg-icon v-if='scope.row.sendType===1' icon-class='to-outside'></svg-icon></div>
                  <span v-if='scope.row.regIsEmergency' style="width: 29px;position: absolute;left: 0;top: 0;display:inline-block;"><img style="width:100%;" src="../../assets/Emergency.png" alt=""></span>
                </div>

               </template>
            </el-table-column>
            <el-table-column prop='sexName' label='性别' width='100px'> </el-table-column>
            <el-table-column prop='age' label='年龄' width='100px'> </el-table-column>
            <el-table-column prop='statusName' label='医疗状态' width='110px'></el-table-column>
            <el-table-column prop='patientNo' label='影像号' width='180px'> </el-table-column>
            <el-table-column prop='patientType' label='患者来源' width='110px'> </el-table-column>
            <el-table-column prop='regNo' label='登记单号' width='180px'> </el-table-column>
            <el-table-column prop='register' label='登记医生' width='110px'> </el-table-column>
        <el-table-column prop='regDt' label='登记时间' min-width="180px"> </el-table-column>-->
        <!-- <el-table-column prop='printedCount' label='是否打印' min-width="180px"> </el-table-column> -->
        <el-table-column prop label="功能" min-width="230px" size="mini" fixed="right">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="影像诊断" placement="top">
              <el-button
                style="background:#44cc79;color:#fff;border:none;float:left;margin-right:10px;"
                type
                size="mini"
                circle
                @click="dbTalble(scope.row)"
              >
                <svg-icon icon-class="writereport"></svg-icon>
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="查看影像" placement="top">
              <el-button
                style="background:#5AB1EF;color:#fff;border:none;float:left;margin-right:10px;"
                type
                size="mini"
                circle
                @click="pacsImg(scope.row.webPacsUrl)"
              >
                <svg-icon icon-class="preview_1"></svg-icon>
              </el-button>
            </el-tooltip>
            <template v-if="scope.row.sendType !== 2">
              <el-tooltip class="item" effect="dark" content="远程会诊" placement="top" v-if="scope.row.statusName === '待诊断' ">
                <el-button
                  style="background:#8470F2;color:#fff;border:none;float:left;margin-right:10px;"
                  type
                  size="mini"
                  circle
                  @click="GetDiagnosticDeparts(scope.row)"
                >
                  <svg-icon icon-class="consultation"></svg-icon>
                </el-button>
              </el-tooltip>
            </template>
            <template  v-if="scope.row.sendType === 2">
              <el-tooltip class="item" effect="dark" content="报告退回" placement="top" v-if="scope.row.statusName === '待诊断' ">
                <el-button style="background:#FF6E6E;color:#fff;float:left;border:none;margin-right:10px;" type="" size='mini' @click="RollBackAllocation(scope.row)" circle><svg-icon  icon-class='reason'></svg-icon></el-button>
              </el-tooltip>
            </template>
            <template v-if="scope.row.sendType !== 2">
              <el-tooltip
                class="item"
                effect="dark"
                content="患者登记修改"
                placement="top"
                v-if="scope.row.statusName === '待诊断'"
              >
                <el-button
                  style="background:#FFB22D;color:#fff;float:left;border:none;margin-right:10px;"
                  type
                  size="mini"
                  circle
                  @click="editRegistration(scope.row)"
                >
                  <svg-icon icon-class="患者登记修改" class="svg2"></svg-icon>
                </el-button>
              </el-tooltip>
            </template>
            <!-- <el-tooltip class="item" effect="dark" content="删除检查" placement="top">
              <el-button
                style="background:#ff8c8c;color:#fff;border:none;"
                type
                size="mini"
                circle
                @click="DeletePerform(scope.row)"
              >
                <i class="el-icon-delete"></i>
              </el-button>
            </el-tooltip> -->
          </template>
        </el-table-column>
      </el-table>
      <div v-else style="width:100%;text-align:center;background:#f8f8f8;">
        <img src="../../assets/empty_01.png" alt style="height: calc(100vh - 353px);width: auto;">
      </div>
    </div>
    <el-row style="text-align: center;" v-if="writeReportList.length > 0">
      <div class="block">
        <el-pagination
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80, 100]"
          :page-size="search.PageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="ReportListtotalCount"
        ></el-pagination>
      </div>
    </el-row>
    <el-dialog
      title="远程会诊"
      :visible.sync="dialogTableVisible"
      width="700px"
      custom-class="revisitDialog"
      ref="dialog"
      @close="close"
    >
      <el-row style="margin-top:20px;border-top:1px solid #397EE3;">
        <el-table
          :data="DiaDeparts"
          stripe
          max-height="300px"
          size="mini"
          height="250"
          v-loading="hospListloading"
          highlight-current-row @current-change="handleCurrentChanges"
        >
          <el-table-column property="hospName" label="医院名称"></el-table-column>
          <el-table-column property="departName" label="科室名称"></el-table-column>
        </el-table>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini' style="" @click="consultation(fillInfors)"> 确 定 </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="退回原因"
      :visible.sync="dialogTableVisibles"
      width="700px"
      custom-class="revisitDialog"
      ref="dialog"
      @close="close"
    >
      <el-row style="margin-top:20px;">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 10}"
          placeholder="请填写退回原因"
          v-model="RollBackAllocations.note">
        </el-input>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="SubmitReturn">确 定</el-button>
      </div>
    </el-dialog>



<el-dialog
  title="影像地址"
  :visible.sync="dialogVisible"
  width="30%"
  >
  <div class="popupImgUrl">
    <a href="javascript:;" v-for="(item,index) in imagesUrl" :key="index" @click="openAi(item)">地址{{index+1}}</a>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">关闭</el-button>
    
  </span>
</el-dialog>
   

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { formatDate } from '@/utils/index.js'
import common from '@/utils/common.js'
export default {
  name: 'Diagnostic',
  data() {
    return {
      interval_latestDispatchedProcedure: null,
      interval_latestFinishedReport: null,
      dialogVisible: false,
      imagesUrl: [],
      loading: false,
      tableloading: false,
      dialogTableVisible: false,
      dialogTableVisibles: false,
      hospListloading: false,
      search: {
      },
      consultations: {
        procedureIds: [],
        departId: '',
        hospId: '',
        destHospId: '',
        destDepartId: '',
        note: ''
      },
      RollBackAllocations: {
        procedureIds: [],
        departId: '',
        hospId: '',
        note: ''
      },
      getTime: common.SettingsTime.value,
      getqueryType: common.SettingsqueryType.value,
      ReportList: [],
      timeType: 0,
      isActive: false,
      navHeight: 102,
      activeName2: 'allList',
      currentPage: 1,
      tableHeader: [
        {
          prop: 'srcHospitalName',
          label: '来源医院'
        },
        {
          prop: 'name',
          label: '诊断医生'
        }
      ],
      fillInfors: '',
      modules: 'GlobalTemplate'
    }
  },
  beforeMount() {},
  beforeDestroy() {
    if (this.interval_latestDispatchedProcedure) {
      clearInterval(this.interval_latestDispatchedProcedure)
    }
    if (this.interval_latestFinishedReport) {
      clearInterval(this.interval_latestFinishedReport)
    }
  },
  mounted() {
    this.interval_latestDispatchedProcedure = setInterval(() => {
      this.getLatestDispatchedProcedure()
    }, 1000 * 60)

    this.interval_latestFinishedReport = setInterval(() => {
      this.getLatestFinishedReport()
    }, 1000 * 60)
  },
  created() {
    // this.search.DateArray = [
    //   formatDate(new Date(), 'yyyy-MM-dd'),
    //   formatDate(new Date(), 'yyyy-MM-dd')
    // ]
    this.search = this.searchReport
    if (new Date(this.search.DateArray[1]).getTime() / (24 * 3600 * 1000) - new Date(this.search.DateArray[0]).getTime() / (24 * 3600 * 1000) === 0) {
      this.timeType = 0
    } else if (new Date(this.search.DateArray[1]).getTime() / (24 * 3600 * 1000) - new Date(this.search.DateArray[0]).getTime() / (24 * 3600 * 1000) === 3) {
      this.timeType = 2
    } else if (new Date(this.search.DateArray[1]).getTime() / (24 * 3600 * 1000) - new Date(this.search.DateArray[0]).getTime() / (24 * 3600 * 1000) === 7) {
      this.timeType = 3
    } else {
      this.timeType = 4
    }
    this.handleClick(this.activeName2)
    this.getChecktype()
  },
  computed: {
    ...mapGetters([
      'writeReportList',
      'dict',
      'userId',
      'ReportVariable',
      'lock',
      'ReportListtotalCount',
      'checkList',
      'currentUserRoleDepart',
      'headerList',
      'DiaDeparts',
      'printInfo',
      'searchReport'
    ]),
    newModality() {
      return this.search.Modality
    }
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (row.isShowWarningTime === 1) {
        return 'warning-row'
      }
      return ''
    },
    handleSizeChange(val) {
      this.search.PageCount = val
      this.onSubmit(1)
    },
    // Excel() {
    //   var days = new Date(this.search.DateArray[1]).getTime() - new Date(this.search.DateArray[0]).getTime()
    //   var time = parseInt(days / (1000 * 60 * 60 * 24))
    //   if (time > 31) {
    //     this.$message({
    //       message: '您所选的时间段大于一个月，不能导出Excel，请重新选择！',
    //       type: 'warning'
    //     })
    //   } else {
    //     var date = new Date(this.search.DateArray[0])
    //     var Y = date.getFullYear() + '-'
    //     var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    //     var D = date.getDate()
    //     var startDate = Y + M + D
    //     var date1 = new Date(this.search.DateArray[1])
    //     var Y1 = date1.getFullYear() + '-'
    //     var M1 = (date1.getMonth() + 1 < 10 ? '0' + (date1.getMonth() + 1) : date1.getMonth() + 1) + '-'
    //     var D1 = date1.getDate()
    //     var endDate = Y1 + M1 + D1
    //     window.open(this.$getCfg('VUE_APP_BASE_API') + '/Statistics/GetRegistrationInfoSheet?departId=' + this.currentUserRoleDepart.departId + '&startDate=' + startDate + '&endDate=' + endDate + '&fileName=', '_blank')
    //   }
    // },

    DeletePerform(datas) {
      this.$store
        .dispatch('DeletePerform', { performId: datas.performId })
        .then(() => {
          this.$message({
            message: '成功删除检查！',
            type: 'success'
          })
          this.onSubmit(1)
        })
        .catch(() => {
          this.$message({
            message: '删除检查失败，请重试！',
            type: 'warning'
          })
        })
    },
    handleCurrentChange(val) {
      this.onSubmit(val)
    },
    handleCurrentChanges(val) {
      this.fillInfors = val
    },
    consultation(row) {
      this.consultations.destHospId = row.hospId
      this.consultations.destDepartId = row.departId
      this.$store
        .dispatch('AddDiagnosticAllocation', this.consultations)
        .then(() => {
          this.onSubmit(1)
        })
        .catch(() => {})
      this.dialogTableVisible = false
    },
    GetDiagnosticDeparts(row) {
      this.consultations.procedureIds = row.procedureIds
      this.consultations.departId = row.srcDeptId
      this.consultations.hospId = row.srcHospitalId
      this.dialogTableVisible = true
      this.$store
        .dispatch('GetDiagnosticDeparts')
        .then(() => {
          // 获取当前科室的可分配科室
        })
        .catch(() => {})
    },
    RollBackAllocation(row) {
      this.RollBackAllocations.procedureIds = row.procedureIds
      this.RollBackAllocations.departId = this.currentUserRoleDepart.departId
      this.RollBackAllocations.hospId = this.currentUserRoleDepart.hospId
      this.dialogTableVisibles = true
    },
    SubmitReturn() {
      this.$store
        .dispatch('RollBackAllocation', this.RollBackAllocations)
        .then(() => {
          this.onSubmit(1)
          // 退回
        })
        .catch(() => {
        })
      this.dialogTableVisibles = false
    },
    toggleClick: function() {
      this.isActive = !this.isActive
    },
    checkTimeType(type) {
      if (type === 0) {
        this.search.DateArray = [formatDate(new Date(), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 1) {
        this.search.DateArray = [formatDate(new Date(new Date() - 3600 * 1000 * 24), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 2) {
        this.search.DateArray = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 3), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 3) {
        this.search.DateArray = [formatDate(new Date(new Date() - 3600 * 1000 * 24 * 7), 'yyyy-MM-dd'), formatDate(new Date(), 'yyyy-MM-dd')]
      }
      if (type === 4) {
        this.search.DateArray = this.search.DateArray
      }
      this.onSubmit(1)
    },
    getBody(value) {
      if (value) {
        var temp = ''
        for (let i = 0; i < this.checkList.checkType.length; i++) {
          if (this.checkList.checkType[i].name === value) {
            temp = this.checkList.checkType[i].modality
            break
          }
        }
        this.$store
          .dispatch('getcheckBody', {
            departId: this.currentUserRoleDepart.departId,
            modality: temp
          })
          .then(() => {
            // 提交登记
          })
          .catch(() => {
            this.$message({
              message: '获取检查部位失败，请重新获取',
              type: 'warning'
            })
          })
      }
    },
    getChecktype() {
      this.$store
        .dispatch('getcheckType', {
          departId: this.currentUserRoleDepart.departId
        })
        .then(() => {
          // 提交登记
        })
        .catch(() => {
          this.$message({
            message: '获取设备类型失败，请重新获取',
            type: 'warning'
          })
        })
    },
    GetTableHeaderConfigs() {
      this.$store
        .dispatch('GetTableHeaderConfigs', {
          departId: this.currentUserRoleDepart.departId,
          type: 3
        })
        .then(() => {})
        .catch(() => {
          this.$message({
            message: '获取表头配置失败，请重新获取',
            type: 'warning'
          })
        })
    },
    handleClick(tab, event) {
      if (tab.name === 'allList') {
        this.search.CompleteStatus = 0
      }
      if (tab.name === 'waitList') {
        this.search.CompleteStatus = 5
      }
      if (tab.name === 'startList') {
        this.search.CompleteStatus = 10
      }
      if (tab.name === 'endList') {
        this.search.CompleteStatus = 20
      }
      this.onSubmit(1)
    },

    onSubmit(val) {
      this.search.PageIndex = val
      this.currentPage = val
      this.table = true
      this.tableloading = true
      this.$store
        .dispatch('GetReportList', this.search)
        .then(() => {
          for (var i = 0; i < this.writeReportList.length; i++) {
            if (this.writeReportList[i].printedCount === 0) {
              this.writeReportList[i].printedCount = '未打印'
            } else {
              this.writeReportList[i].printedCount = '已打印'
            }
          }
          this.GetTableHeaderConfigs()
          this.loading = false
          this.tableloading = false
        })
        .catch(() => {
          this.loading = false
          this.tableloading = false
        })
    },
    resetForm() {
      this.$refs['search'].resetFields()
      this.search.Modality = ''
      this.search.bodyPart = ''
    },
    NewReport: function(row) { // 初次保存状态为50/80时
      var CreateOrUpdateReport = {// 保存更新报告
        reportId: row.reportId,
        performId: row.performId,
        regId: row.regId,
        wys: row.wys,
        wyg: row.wyg,
        status: row.status,
        isEmergency: row.isEmergency,
        isPositive: row.isPositive,
        procedureIds: row.procedureIds,
        isDeleted: false,
        departId: row.departId,
        qcScore: row.qcScore
      }
      this.$store
        .dispatch('NewReport', CreateOrUpdateReport)
        .then(() => {
          this.ReportInfo(row)
        })
        .catch(() => {
          this.loading = false
        })
    },
    StatusRejectedToDiagnosing: function(row) {
      var CreateOrUpdateReport = {// 保存更新报告
        reportId: row.reportId,
        performId: row.performId,
        regId: row.regId,
        wys: row.wys,
        wyg: row.wyg,
        status: row.status,
        isEmergency: row.isEmergency,
        isPositive: row.isPositive,
        procedureIds: row.procedureIds,
        isDeleted: false,
        departId: row.departId,
        qcScore: row.qcScore
      }
      this.$store
        .dispatch('StatusRejectedToDiagnosing', CreateOrUpdateReport)
        .then(() => {
          this.ReportInfo(row)
        })
        .catch(() => {
          this.loading = false
        })
    },
    ReportInfo: function(datas) { // 获取报告信息
      this.fullloading = true
      this.$store
        .dispatch('GetReportByProcedureId', datas.procedureId)
        .then(() => {
          this.gettemplate(datas)
        })
        .catch(() => {
          this.loading = false
        })
    },
    gettemplate: function(datas) {
      this.$store
        .dispatch('getTemplate', { reportId: this.printInfo.reportId, templateType: this.modules, departId: this.printInfo.departId })
        .then(() => {
          this.$store.dispatch('getReportVariable').then(() => {})
          this.$router.push({ path: '/writereport' })
          this.pacsImg(datas.webPacsUrl)
          this.$message({ message: '操作成功', type: 'success' })
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    dbTalble: function(row) {
      this.loading = true
      this.$store
        .dispatch('getLock', {
          procedureId: row.procedureId,
          departId: this.currentUserRoleDepart.departId
        })
        .then(() => {
          if (this.lock.data) {
            if (row.status === 45) {
              sessionStorage.setItem(
                'setReportVariable',
                JSON.stringify({ procedureId: row.procedureId, type: '1' })
              ) // 添加到sessionStorage
              this.StatusRejectedToDiagnosing(row)
            } else if (row.status === 50) {
              sessionStorage.setItem(
                'setReportVariable',
                JSON.stringify({ procedureId: row.procedureId, type: '1' })
              ) // 添加到sessionStorage
              this.NewReport(row)
            } else if (row.status === 60) {
              sessionStorage.setItem(
                'setReportVariable',
                JSON.stringify({ procedureId: row.procedureId, type: '1' })
              ) // 添加到sessionStorage
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport' })
              this.pacsImg(row.webPacsUrl)
              this.$message({ message: '操作成功', type: 'success' })
              this.loading = false
            } else if (row.status > 60) {
              sessionStorage.setItem(
                'setReportVariable',
                JSON.stringify({ procedureId: row.procedureId, type: '1' })
              ) // 添加到sessionStorage
              this.$store.dispatch('getReportVariable').then(() => {})
              this.$router.push({ path: '/writereport' })
              this.pacsImg(row.webPacsUrl)
              this.$message({ message: '操作成功', type: 'success' })
              this.loading = false
            }
          } else {
            this.$message({ message: this.lock.message, type: 'success' })
            this.loading = false
          }
        })
        .catch(() => {
          this.$message({ message: this.lock.message, type: 'success' })
          this.loading = false
        })
    },
    changeTime: function() {
      this.timeType = 4
    },
    editRegistration(data) {
      this.$router.push({
        path: '/editConsultation',
        name: 'EditConsultation',
        query: { regId: data.regId, consultation: true, isReoprt: true }
      })
    },
    pacsImg: function(url) {
      window.open(
        url,
        'pacsImg',
        'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes'
      )
    },
    getLatestFinishedReport() {
      if (!this.$store.getters.voiceNotifyFinishedReport) { return }
      this.$store
        .dispatch('GetLatestFinishedReport')
        .then((res) => {
          if (res.latestFinishedReport) {
            const reportId = res.latestFinishedReport.reportId
            const modality = res.latestFinishedReport.modality
            const finishedTime = res.latestFinishedReport.finishedTime
            const latestFinishedReportStr = reportId + '&' + modality + '&' + finishedTime

            const storeLatestDispatchedProcedure = localStorage.getItem('latestFinishedReport')
            if (!storeLatestDispatchedProcedure) {
              localStorage.setItem('latestFinishedReport', latestFinishedReportStr)
              this.playAudioForFinishedReport(modality)
            } else {
              if (storeLatestDispatchedProcedure !== latestFinishedReportStr) {
                localStorage.setItem('latestFinishedReport', latestFinishedReportStr)
                this.playAudioForFinishedReport(modality)
              }
            }
          }
        })
        .catch(() => {
        })
    },
    playAudioForFinishedReport(modality) {
      let audioSrc = ''
      audioSrc = require('../../assets/audios/FinishedReport.mp3')
      const msgContent = '您有已完成的新报告'
      this.playAudio(audioSrc, msgContent)
    },
    getLatestDispatchedProcedure() {
      if (!this.$store.getters.voiceNotify) { return }
      this.$store
        .dispatch('GetLatestDispatchedProcedure')
        .then((res) => {
          if (res.latestDispatchedProcedure) {
            const procedureId = res.latestDispatchedProcedure.procedureId
            const modality = res.latestDispatchedProcedure.modality
            const dispatchTime = res.latestDispatchedProcedure.dispatchTime
            const latestDispatchedProcedureStr = procedureId + '&' + modality + '&' + dispatchTime

            const storeLatestDispatchedProcedure = localStorage.getItem('latestDispatchedProcedure')
            if (!storeLatestDispatchedProcedure) {
              localStorage.setItem('latestDispatchedProcedure', latestDispatchedProcedureStr)
              this.playAudioForDispatchedProcedure(modality)
            } else {
              if (storeLatestDispatchedProcedure !== latestDispatchedProcedureStr) {
                localStorage.setItem('latestDispatchedProcedure', latestDispatchedProcedureStr)
                this.playAudioForDispatchedProcedure(modality)
              }
            }
          }
        })
        .catch(() => {
        })
    },
    playAudioForDispatchedProcedure(modality) {
      let audioSrc = ''
      let msgContent = ''
      if (modality.toUpperCase() === 'CT') {
        audioSrc = require('../../assets/audios/CT.mp3')
        msgContent = '您有新的CT待写报告'
      } else if (modality.toUpperCase() === 'MR') {
        audioSrc = require('../../assets/audios/MR.mp3')
        msgContent = '您有新的MR待写报告'
      } else if (modality.toUpperCase() === 'DR') {
        audioSrc = require('../../assets/audios/DR.mp3')
        msgContent = '您有新的DR待写报告'
      }

      if (!audioSrc) {
        return
      }
      this.playAudio(audioSrc, msgContent)
    },
    playAudio(audioSrc, msgContent) {
      if (!audioSrc) {
        this.$message({
          message: 'audioSrc没有设置',
          type: 'warning'
        })
        return
      }
      if (!msgContent) {
        msgContent = '您有一条新的语音提示消息，点击可播放消息'
      }
      const msgArray = []
      const audioHtml = '<iframe src="' + audioSrc + '" type="audio/mpeg" allow="autoplay"/>'
      msgArray.push('<div>' + msgContent)
      msgArray.push('<div style="display:none;">')
      msgArray.push(audioHtml)
      msgArray.push('</div>')
      msgArray.push('</div>')
      const msgHtml = msgArray.join('')
      this.$message({
        dangerouslyUseHTMLString: true,
        message: msgHtml,
        duration: 0,
        showClose: true
      })
    },
    openAi(url) {
      // dialogVisible
      if (url) {
        var Website = url.split(',')
        if (Website.length === 1) {
          window.open(
            Website[0],
            'ai',
            'top=0, left=0, toolbar=no, menubar=no, scrollbars=yes, resizable=no, location=no, status=no, channelmode=yes, fullscreen=yes'
          )
        } else {
          this.dialogVisible = true
          this.imagesUrl = Website
        }
      }
    },
    close() {
      this.ConHospList = []
    }
  },
  watch: {
    searchReport: {
      handler: function(newVal, oldVal) {
        this.$store.dispatch('GetSearchReport', newVal)
      },
      deep: true
    },
    $route() {
      this.$store.dispatch('resetdiagnostic')
    },
    newModality(val) {
      this.search.bodyPart = ''
      this.getBody(this.search.Modality)
    },
    timeType(type) {
      this.checkTimeType(type)
    }
  },
  filters: {
    checkingItems(datas) {
      if (datas) {
        if (datas.length > 11) {
          datas = datas.slice(0, 10) + '…'
        }
        return datas
      } else {
        return ''
      }
    }
  }
}
</script>
<style rel='stylesheet/scss' lang='scss' scoped>
.reportList {
  height: 100%;
  overflow-y: auto;
  .el-tabs {
    padding: 0px 20px;
    margin-top: 20px;
  }
  .reportList-nav {
    height: auto;
    background: #f8f8f8;
    margin: 0px 20px 20px 20px;
    padding: 10px;
    .el-form-item {
      margin-bottom: 10px;
    }
    // .el-checkbox-button, .el-checkbox-button__inner{
    //   margin-right: 10px;
    // }
  }
  .reportList-table {
    border-top: 2px solid #ddd;
    background: #f3f5f9;
    margin: 20px;
  }
  .hamburger {
    transform: rotate(0deg);
    transition: 0.38s;
    transform-origin: 50% 50%;
  }
  .hamburger.is-active {
    transform: rotate(180deg);
  }
  .toggleSearch {
    height: 0px;
    -webkit-transition: height 0.28s;
    transition: height 0.28s;
    overflow: hidden;
  }
  .toggleSearchType .toggleSearch {
    height: 110px;
    -webkit-transition: height 0.28s;
    transition: height 0.28s;
    overflow: hidden;
  }
  .name-wrapper {
    height: 23px;
    span {
      background: #ff9d60;
      color: #fff;
      padding: 4px 5px;
      border-radius: 3px;
      width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }
  .nav-top {
    .el-form-item {
      width: 12.5%;
    }
  }
  
}
.popupImgUrl{display: flex;}
.popupImgUrl a{margin: 20px 20px 20px 0; display: block; }
.popupImgUrl a:hover{color: #397EE3}
</style>
